
<div class="container">
  <div class="row">
    <div class="col">
      <p class="text-center">Import the Project Structure spreadsheet</p>
    </div>
  </div>
  <div class="row">
    <div class="col"> </div>
    <div class="col"><a class="btn btn-primary btn-block" [uploadFileTo]="'/api/projects/import-structure?projectId=' + projectId" [fileExtensions]="['xls', 'xlsx', 'xlsm', 'xlsb']" [title]="'Import Project Structure Form'"><span class="oi oi-cloud-upload"></span> Upload Project Structure Form</a></div>
    <div class="col"> </div>
  </div>
</div>